import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { ScrollDispatcher } from '@angular/cdk/overlay';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})


export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  init = false;
  navActive = false;
  navMobileBottom = false;

  logoUrl = '';
  logoAltUrl = '';

  protected adminTypeSubscription: Subscription;

  constructor(public gs: GeneralService,
              private scroll: ScrollDispatcher) {    
                
    this.scroll.scrolled().subscribe(this.onWindowScroll);
           
    this.logoUrl = this.gs.buildImagemUrl('logo.png');
    this.logoAltUrl = this.gs.buildImagemUrl('logo-white.png');

    this.adminTypeSubscription = this.gs.adminType$.subscribe(result => {
      this.navMobileBottom = ['builder','realtor','admin','profile'].indexOf(result) > -1;
    });

  }

  private onWindowScroll() {
    const scrollTop = window.pageYOffset;
    const el = document.getElementsByClassName("site-header-wrapper")[0];
  
    if (scrollTop < environment.options.headerScrollTop) {
        el.classList.remove('scroll');
    } else {
        el.classList.add('scroll');
    }
  }

  ngAfterViewInit(){
    this.init = true;
  }

  ngOnInit() {
    this.gs.options$.subscribe(results => {
      environment.options = results;
      
    });
  }

  ngOnDestroy(){
    this.adminTypeSubscription.unsubscribe();
  }

  onClick(action){
    switch(action){
      case 'nav':
        this.navActive = !this.navActive;
      break;
    }
  }

  headerIsFluid(){
    return environment.options.headerFluid;
  }

}
